import { updateOrganisation } from '@infuse/api/iam/organisation';
import { useGenericUpdateOrganisation } from './generic/useGenericUpdateOrganisation';
import { useCurrentUserStore } from '@infuse/iam/user/store';
import { UserLevel } from '@infuse/iam/user/type';
import { updateTenantOrganisation } from '@infuse/api/iam/tenant';

export const useUpdateOrganisation = () => {
  const { level, user } = useCurrentUserStore();

  if (level === UserLevel.TENANT) {
    return useGenericUpdateOrganisation({
      apiFn: updateTenantOrganisation,
      forcedParentId: user?.tenantId
    });
  }

  return useGenericUpdateOrganisation({
    apiFn: updateOrganisation
  });
};
